/**
 * Library Page
 * 
 * Main page component for the Library feature.
 * Wraps LibrarySidebar and LibraryContent with LibraryProvider.
 */

import React from 'react';
import { LibraryProvider } from './LibraryContext';
import LibrarySidebar from './components/LibrarySidebar';
import LibraryContent from './components/LibraryContent';
import PageLayout from '../../components/layout/PageLayout/PageLayout';
import styles from './styles/Library.module.css';

export default function LibraryPage() {
  return (
    <PageLayout
      activeNavItem="library"
      currentPage="Library"
      breadcrumbItems={[{ label: 'Home', path: '/athena' }]}
      contentClassName={styles.fullWidthContent}
      disableScroll={true}
    >
      <LibraryProvider>
        <div className={styles.libraryContainer}>
          <LibrarySidebar />
          <LibraryContent />
        </div>
      </LibraryProvider>
    </PageLayout>
  );
}
